import { FeatureName, Features } from '@bybeam/platform-types';

function checkFeature(features: Features | undefined, featureName: FeatureName): boolean {
  return !!features?.find((f) => f.feature.name === featureName && f.enabled === true);
}

function checkFeatures(features: Features | undefined, featureNames: FeatureName[]): boolean {
  return featureNames.every((featureName) => checkFeature(features, featureName));
}

function checkNoFeatures(features: Features | undefined, featureNames: FeatureName[]): boolean {
  return featureNames.every((featureName) => !checkFeature(features, featureName));
}

export { checkFeature, checkFeatures, checkNoFeatures };
